import data from "../../shared/sharedData";
import page0Mutation from "./mutations/page0Mutations";
export default {
  name: "Job Order Cover Sheet",
  symbol: "document",
  pageInfo: {
    text: "<b>IMPORTANT: </b> Employers and authorized preparers must read these general instructions carefully before completing the Form ETA-790A, Agricultural Clearance Order, and all required addendums. These instructions contain explanations of the questions and assurances that make up the Form ETA-790A. Please complete ALL required fields/items containing an asterisk (*).<br/><br/>It is a federal offense to knowingly and willfully furnish materially false information in the preparation of the Form ETA-790A and any supplement thereto or to aid, abet, or counsel another to do so (18 U.S.C. §§ 2, 1001). Other penalties may also apply to fraud or misuse of this immigration document and to perjury with respect to this form (18 U.S.C. §§ 1546, 1621).",
    coloring: "grey",
  },
  mutations: {
    ...page0Mutation,
  },
  sections: [
    {
      name: "Employer Name(s)",
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select an Employer profile to populate this section (optional)",
          code: "II",
          prefill: {
            schema: "employerProfiles",
            type: "employer",
            formName: "790A",
            formSection: "II",
          },
        },
        {
          code: "II.1",
          machine_name: "eta_790_b1_poc_name",
          widget: "text",
          label: "Legal Business Name",
          validate: [
            "required",
            {
              minLength: 2,
              message: "Legal Business Name must contain at least 2 characters",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the full legal name of the business, person, association, firm, corporation, or organization, i.e., the employer filing
            this application. The employer’s full legal name is the exact name of the individual, corporation, LLC, partnership, or other
            organization that is reported to the Internal Revenue Service (IRS). The entry in this field must be the same as the entry
            in Section B, Item 1 of the Form ETA-9142A.`,
        },
        {
          code: "II.2",
          machine_name: "eta_790_b2_poc_dba",
          widget: "text",
          label: "Trade Name / Doing Business As (DBA)",
          validate: [
            {
              minLength: 5,
              message:
                "Trade Name/Doing Business As (DBA) must contain at least 5 characters",
            },
          ],
          maxLength: 120,
          tooltip: `Enter the full trade name or “Doing Business As” (DBA) name, if applicable, of the business, person, association, firm,
            corporation, or organization. The entry in this field must be the same as the entry in Section B, Item 2 of the Form ETA9142A. Do not include “DBA” in front of the full trade name entered in Item 2 or at the end of the full legal name entered in
            Item 1.`,
        },
        {
          code: "II.15",
          machine_name: "eta_790_b15_poc_fein",
          widget: "text",
          label:
            "<span>Federal Employer Identification Number <i>(FEIN from IRS)</i></span>",
          validate: ["required", "fein", { minLength: 10 }],
          parse: "fein",
          maxLength: 10,
          tooltip:
            "Enter the nine-digit Federal Employer Identification Number (FEIN) as assigned by the IRS. <u>Do not enter a social security number</u>.  The entry in this field must be the same as the entry in Section B, Item 12 of the Form ETA-9142A. <br/><em>Important Note</em>: All employers, <u>including private households</u>, MUST obtain an FEIN from the IRS before completing this application.  Information on obtaining an FEIN can be found at <a href='http://www.irs.gov'>www.IRS.gov</a>.",
        },
        {
          code: "II.16",
          machine_name: "eta_790_b16_poc_naics_description",
          widget: "text",
          label: "NAICS Description",
          //validate: ["required"],
          hidden: true,
        },
        {
          code: "II.16",
          machine_name: "eta_790_b16_poc_naics",
          widget: "naics",
          field_to_modify: "eta_790_b16_poc_naics_description",
          label: "NAICS Code",
          validate: ["required"],
          tooltip:
            'Enter the four-digit North American Industry Classification System (NAICS) code that most closely corresponds to the employer’s primary economic or business activity; not the specific job opportunity being requested for temporary labor certification.  For example, an employer primarily engaged in a combination of apple, citrus, and berry farming, would select NAICS Code “1113.”  The first two digits identifies the major economic sector (e.g., 11 –Agriculture, Forestry, Fishing and Hunting); the third digit identifies the subsector (e.g., 1 – Crop Production); and the fourth digit identifies the industry group (e.g., 3 – Fruit and Tree Nut Farming). Additional information concerning the NAICS can be found at <a href="http://www.census.gov/epcd/www/naics.html">http://www.census.gov/epcd/www/naics.html</a>.  The entry in this field must be the same as the entry in Section B, Item 13 of the Form ETA-9142A.',
        },
      ],
    },
    {
      name: "Employer Point-of-Contact Information",
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select a Point-of-Contact profile to populate this section (optional)",
          prefill: {
            schema: "employerPocs",
            type: "employer-pocs",
            formName: "790A",
            formSection: "II",
          },
        },
        {
          code: "II.3",
          machine_name: "eta_790_b3_poc_last",
          widget: "text",
          label: "Contact's Last (family) Name",
          validate: [
            "required",
            {
              minLength: 2,
              message:
                "Contact's last (family) name must contain at least 2 characters",
            },
          ],
          parse: ["noNumbers"],
          maxLength: 35,
          tooltip: `Enter the last (family) name of the employer’s point of contact. The entry in this field must be the same as the entry in
            Section C, Item 1 of the Form ETA-9142A.`,
        },
        {
          code: "II.4",
          machine_name: "eta_790_b4_poc_first",
          widget: "text",
          label: "First (given) Name",
          validate: [
            "required",
            {
              minLength: 2,
              message: "First (given) name must contain at least 2 characters",
            },
          ],
          parse: ["noNumbers"],
          maxLength: 35,
          tooltip: `Enter the first (given) name of the employer’s point of contact. The entry in this field must be the same as the entry in
            Section C, Item 2 of the Form ETA-9142A.`,
        },
        {
          code: "II.5",
          machine_name: "eta_790_b5_poc_middle",
          widget: "text",
          label: "Middle name(s)",
          parse: ["noNumbers"],
          maxLength: 35,
          tooltip: `Enter the middle name of the employer’s point of contact, if applicable. Enter “N/A” if not applicable. The entry in this field
            must be the same as the entry in Section C, Item 3 of the Form ETA-9142A.`,
        },
        {
          code: "II.6",
          machine_name: "eta_790_b6_poc_job_title",
          widget: "text",
          label: "Contact's Job Title",
          validate: [
            "required",
            {
              minLength: 2,
              message:
                "Contract's job title must contain at least 2 characters",
            },
          ],
          maxLength: 60,
          tooltip: `Enter the job title of the employer's point of contact. The entry in this field must be the same as the entry in Section C,
            Item 4 of the Form ETA-9142A`,
        },
      ],
    },
    {
      fields: [
        {
          code: "II.7",
          machine_name: "eta_790_b7_poc_address_1",
          widget: "text",
          label: "Address 1",
          validate: [
            "required",
            {
              minLength: 5,
              message: "Address 1 must contain at least 5 characters",
            },
          ],
          maxLength: 60,
          tooltip: `. Enter the business street address for the employer’s point of contact. The address must be a physical location and not a
            P.O. box. The entry in this field must be the same as the entry in Section C, Item 5 of the Form ETA-9142A.`,
        },
        {
          code: "II.8",
          machine_name: "eta_790_b8_poc_address_2",
          widget: "text",
          label: "<span>Address 2 <i>(suite/floor and number)</i></span>",
          maxLength: 60,
          tooltip: `If additional space is needed for the street address, use this field to complete the street address. If no additional space is
            needed, enter “N/A.” The entry in this field must be the same as the entry in Section C, Item 6 of the Form ETA-9142A.`,
        },
        {
          code: "II.9",
          machine_name: "eta_790_b9_poc_city",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: `Enter the city of the employer’s point of contact. The entry in this field must be the same as the entry in Section C, Item 7
            of the Form ETA-9142A.`,
        },
        {
          code: "II.10",
          machine_name: "eta_790_b10_poc_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          state: true,
          validate: ["required"],
          tooltip: `Enter the State, district or territory of the employer’s point of contact. The entry in this field must be the same as the entry
            in Section C, Item 8 of the Form ETA-9142A.`,
        },
        {
          code: "II.11",
          machine_name: "eta_790_b11_poc_zip",
          widget: "text",
          label: "Postal Code",
          validate: ["required", "postal"],
          maxLength: 10,
          tooltip: `Enter the postal (zip) code of the employer’s point of contact. The entry in this field must be the same as the entry in
            Section C, Item 9 of the Form ETA-9142A.`,
        },
      ],
    },
    {
      fields: [
        {
          code: "II.12",
          machine_name: "eta_790_b12_poc_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          tooltip: `Enter the area code and business telephone number of the employer’s point of contact. Include country code, if the point
            of contact is located outside of the United States. The entry in this field must be the same as the entry in Section C, Item
            12 of the Form ETA-9142A.`,
        },
        {
          code: "II.13",
          machine_name: "eta_790_b13_poc_phone_ext",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber", //don't allow decimal Number and negative number // not working for me? -NG
          maxLength: 4,
          tooltip: `Enter the extension of the telephone number of the employer’s point of contact, if applicable. The entry in this field must
            be the same as the entry in Section C, Item 13 of the Form ETA-9142A.`,
        },
        {
          code: "II.14",
          machine_name: "eta_790_b14_poc_email",
          widget: "text",
          label: "Business email address",
          validate: [
            "required",
            {
              email: {
                extraData: {
                  allowNAs: true,
                  onlyOne: true,
                },
              },
            },
          ],
          maxLength: 55,
          tooltip: `Enter the business e-mail address of the employer’s point of contact in the format <u>name@emailaddress.top-leveldomain</u>.
            The e-mail entered in this field must be the same as the one regularly used by the employer’s point of contact for its
            business operations and capable of sending and receiving electronic communications from the SWA with respect to the
            processing of this agricultural clearance order. If the employer’s point of contact does not possess a business e-mail
            address, please enter “N/A.” The entry in this field must be the same as the entry in Section C, Item 14 of the Form ETA9142A.`,
        },
        {
          code: "II.14.A",
          machine_name: "eta_790_b14a_poc_email_addit",
          widget: "text",
          label: "Additional email address",
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
          ],
          maxLength: 55,
          tooltip:
            "Enter an additional business email address of the employer’s point of contact in the format <u>name@emailaddress.top-leveldomain</u>.  The email entered in this field must be the same as the one regularly used by the employer’s point of contact for its business operations and capable of sending and receiving electronic communications from the SWA with respect to the processing of this agricultural clearance order.  If the employer’s point of contact does not possess a business email address, please enter “N/A”. The entry in this field must be the same as the entry in Section C, Item 14 of the Form ETA-9142A",
        },
      ],
    },
  ],
};
